// The same Google Ads conversion action /thankyou fires for the site's forms.
const SEND_TO = "AW-618149115/FQ6dCKHy7cYDEPvp4KYC"

const hasConsented = () =>
  document.cookie.split("; ").some((row) => row === "faceInstituteCookie=true")

// Only with cookie consent, like /thankyou, and with the same enhanced
// conversion fields so Google can match the booking to the ad click.
export const fireBookingConversion = ({
  email,
  phone,
  firstName,
  lastName,
}) => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return
  if (!hasConsented()) return
  const userData = {}
  if (email) userData.email = email.toLowerCase().trim()
  if (phone) userData.phone_number = phone.replace(/[\s\-()]/g, "")
  if (firstName) userData.first_name = firstName.trim()
  if (lastName) userData.last_name = lastName.trim()
  const data = { send_to: SEND_TO }
  if (Object.keys(userData).length) data.user_data = userData
  window.gtag("event", "conversion", data)
}
